/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { SecurityHelper } from 'sarsaparilla';
import NewPreferencesModal from './NewPreferencesModal';
import NotLoggedInModal from './NotLoggedInModal';
import PreferencesManagementModal from './TripPreferencesManagementModal';
import { useTripPreferences } from './TripPreferenceContext';

function TripPreferencesModal() {
    const {
        isOpenPreferencesModal: isOpen,
        onApplyPreferences,
        loaded,
        preferences,
        isEnabled,
        onPreferenceModal,
        openManagementAfterLogin,
        onOpenManagementAfterLogin,
        applyPreferencesAfterUpdate,
    } = useTripPreferences();

    // Local states
    const [checked, setChecked] = React.useState<string[]>([]);
    const [notLoggedAttempt, setNotLoggedAttempt] = React.useState<boolean>(false);
    const [proceed, setProceed] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (notLoggedAttempt && !isOpen) {
            setNotLoggedAttempt(false);
            if (openManagementAfterLogin) {
                onPreferenceModal(true);
                onOpenManagementAfterLogin(false);
            } else {
                onApplyPreferences();
            }
        }
    }, [loaded]);

    React.useEffect(() => {
        if (
            typeof preferences === 'object' &&
            !isEmpty(preferences) &&
            preferences?.length > 0 &&
            !isOpen
        ) {
            setChecked(preferences);
        }
    }, [preferences]);

    const handleCancel = (): void => {
        setProceed(false);
        onPreferenceModal(false);
    };

    const handleNotLoggedAttempt = () => {
        setNotLoggedAttempt(true);
    };

    if (!SecurityHelper.isLoggedIn()) {
        return (
            <NotLoggedInModal
                onChange={handleNotLoggedAttempt}
                closeModal={handleCancel}
                isOpen={isOpen}
            />
        );
    }
    if (isEmpty(preferences) && !proceed) {
        return (
            <NewPreferencesModal
                onChange={setProceed}
                closeModal={handleCancel}
                isOpen={isOpen}
            />
        );
    }
    return (
        <PreferencesManagementModal
            onChange={setChecked}
            closeModal={handleCancel}
            isOpen={isOpen}
            checked={checked}
            preferences={preferences}
            isEnabled={isEnabled ?? applyPreferencesAfterUpdate}
            onApplyPreferences={onApplyPreferences}
        />
    );
}

export default TripPreferencesModal;
